import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PhoneAuth from './components/PhoneAuth';
import GuarantorForm from './components/GuarantorForm';
import { LanguageProvider } from './contexts/LanguageContext';
import LanguageSwitch from './components/LanguageSwitch';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <LanguageSwitch />
        <Routes>
          <Route path="/" element={<PhoneAuth />} />
          <Route path="/form" element={<GuarantorForm />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
